export const logoSVG = (theme, style) => {
  // function to get r g b values from theme key
  const getRGBFromKey = key => {
    const rgb = theme[key].split(' ');
    return {
      r: parseInt(rgb[0]),
      g: parseInt(rgb[1]),
      b: parseInt(rgb[2]),
    };
  };

  // function to get hexa color from theme key
  const getHexaFromKey = key => {
    const rgb = getRGBFromKey(key);
    return rgbToHex(rgb);
  };

  // function to get hexa color from r g b values
  const rgbToHex = ({ r, g, b }) => {
    const componentToHex = c => {
      const hex = c.toString(16);
      return hex.length === 1 ? '0' + hex : hex;
    };
    return '#' + componentToHex(r) + componentToHex(g) + componentToHex(b);
  };

  // contrast : getHexaFromKey('contrast')
  // primary : getHexaFromKey('primary')
  // primary-l : getHexaFromKey('primary-l')
  // primary-d : getHexaFromKey('primary-d')
  // main : getHexaFromKey('main')

  return (
    <svg
      version='1.1'
      id='Calque_1'
      xmlns='http://www.w3.org/2000/svg'
      x='0px'
      y='0px'
      viewBox='0 0 292 472'
      style={style}
    >
      <radialGradient
        id='SVGID_1_'
        cx='146.1667'
        cy='235.7733'
        r='198.57'
        fx='145.8748'
        fy='320.1688'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          style={{ stopColor: getHexaFromKey('main') }}
        />
        <stop
          offset='1'
          style={{ stopColor: getHexaFromKey('contrast') }}
        />
      </radialGradient>
      <polyline
        style={{ fill: 'url(#SVGID_1_)' }}
        points='146.55,-0.42 0.17,349.58 146.06,471.96 292.17,349.58 146.55,-0.42 '
      />
      <polyline
        style={{ fil: getHexaFromKey('primary-d') }}
        points='145.49,194.02 54.17,261.58 49.17,368.58 145.18,439.67 238.17,368.58 238.17,265.58 145.49,194.02 
        '
      />
      <polygon
        style={{ fill: getHexaFromKey('contrast') }}
        points='142.17,259.29 121.17,274.58 96.17,287.58 96.17,316.72 96.17,345.3 119.17,358.15 145.17,374.63 
        171.01,358.81 195.17,345.58 195.17,316.96 195.17,288.95 169.17,274.58 148.17,259.58 178.17,255.58 216.17,299.58 210.17,350.58 
        159.02,387.48 100.17,375.58 69.74,330.57 78.96,272.53 119.34,247.76 '
      />
      <g>
        <linearGradient
          id='SVGID_00000111886613341383232890000017742872088580464035_'
          gradientUnits='userSpaceOnUse'
          x1='145.9579'
          y1='453.9871'
          x2='146.4188'
          y2='31.5597'
        >
          <stop
            offset='0'
            style={{ stopColor: getHexaFromKey('primary') }}
          />
          <stop
            offset='1'
            style={{ stopColor: getHexaFromKey('primary-l') }}
          />
        </linearGradient>
        <path
          style={{
            fill: 'url(#SVGID_00000111886613341383232890000017742872088580464035_)',
          }}
          d='M146.53,23.83l-0.46-1.02L0.56,349.33
            l-0.16,0.36l145.67,110.02l145.36-109.78l0.32-0.24L146.53,23.83z M146.72,92.03l59.35,102.5l-59.35-87.27l-59.7,87.27
            L146.72,92.03z M234.28,368.17l-0.19,0.1l-0.06,0.04l-88.85,71.36l-0.31-0.25L56.3,368.3l-0.04-0.03l-0.19-0.1V265.28l0.19-0.1
            l0.06-0.04l88.86-71.37l0.31,0.25l88.56,71.13l0.04,0.03l0.19,0.1V368.17z'
        />

        <linearGradient
          id='SVGID_00000157271133886901436620000009145624513655307139_'
          gradientUnits='userSpaceOnUse'
          x1='145.1717'
          y1='177.7592'
          x2='145.1717'
          y2='370.653'
        >
          <stop
            offset='0'
            style={{ stopColor: getHexaFromKey('primary') }}
          />
          <stop
            offset='1'
            style={{ stopColor: getHexaFromKey('primary-l') }}
          />
        </linearGradient>
        <path
          style={{
            fill: 'url(#SVGID_00000157271133886901436620000009145624513655307139_)',
          }}
          d='M57.57,266.15V367.3l87.61,50.58
            l87.6-50.58V266.15l-87.6-50.59L57.57,266.15z M113.9,267.55l1.44-2.5h15.99l-8.66,5h-4.44l-2.22,3.85l-4.34,2.5l-4.32,2.5
            L113.9,267.55z M93.5,312.88l-2.22,3.84l2.22,3.85v10l-6.55-11.35l-1.44-2.5l1.44-2.5l6.55-11.34V312.88z M115.34,368.4l-1.44-2.5
            l-6.55-11.35l4.32,2.5l4.34,2.5l2.22,3.85h4.44l8.66,5H115.34z M176.45,365.9l-1.44,2.5h-15.99l4.33-2.5l4.33-2.5h4.44l2.22-3.84
            l4.34-2.51l4.32-2.5L176.45,365.9z M196.85,320.57l2.22-3.85l-2.22-3.84v-10l6.55,11.34l1.45,2.5l-1.45,2.5l-6.55,11.35V320.57z
             M175.01,265.05l1.44,2.5L183,278.9l-4.32-2.5l-4.34-2.5l-2.22-3.85h-4.44l-4.33-2.5l-4.33-2.5H175.01z M153.35,267.55l4.33,2.5
            l21.66,12.51l4.34,2.5l4.32,2.5l3.85,2.22v53.89l-3.85,2.22l-4.32,2.5l-4.34,2.5l-21.66,12.51l-4.33,2.5l-4.33,2.5l-3.84,2.22
            l-3.85-2.22l-8.66-5l-21.66-12.51l-4.34-2.5l-4.32-2.5l-3.85-2.22v-53.89l3.84-2.22l4.33-2.5l4.34-2.5l21.66-12.51l8.66-5
            l3.85-2.22l3.84,2.22L153.35,267.55z'
        />
        <polygon
          style={{ fill: getHexaFromKey('primary-l') }}
          points='106.91,294.63 106.91,338.82 145.18,360.92 183.45,338.82 183.45,294.63 145.18,272.53 	'
        />
      </g>
    </svg>
  );
};
